var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#EA9F2A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 12.4192 29.3482 9.99069 28.2004 7.86998C25.5628 5.56413 22.1106 4.16699 18.332 4.16699C10.0478 4.16699 3.33203 10.8827 3.33203 19.167C3.33203 21.7478 3.98378 24.1763 5.13167 26.297C7.76919 28.6029 11.2214 30 15 30Z",
    fill: "#F5AB38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 12.333H15.9999M11.5066 21.6663H18.4933C20.3333 21.6663 21.0666 20.5397 21.1533 19.1663L21.4999 13.6597C21.5933 12.2197 20.4466 10.9997 18.9999 10.9997C18.5933 10.9997 18.2199 10.7663 18.0333 10.4063L17.5533 9.43967C17.2466 8.83301 16.4466 8.33301 15.7666 8.33301H14.2399C13.5533 8.33301 12.7533 8.83301 12.4466 9.43967L11.9666 10.4063C11.7799 10.7663 11.4066 10.9997 10.9999 10.9997C9.55328 10.9997 8.40662 12.2197 8.49995 13.6597L8.84662 19.1663C8.92662 20.5397 9.66662 21.6663 11.5066 21.6663ZM14.9999 18.9997C16.1933 18.9997 17.1666 18.0263 17.1666 16.833C17.1666 15.6397 16.1933 14.6663 14.9999 14.6663C13.8066 14.6663 12.8333 15.6397 12.8333 16.833C12.8333 18.0263 13.8066 18.9997 14.9999 18.9997Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.32f5be124054866377657f4f0a9faca1.svg";
export { ForwardRef as ReactComponent };